import React from 'react';
import { TargetHover } from './TargetHover';
import { VectorTileHover } from './VectorTileHover';
import { useLayers } from '@ais-ui/react-openlayers';
import { LayerHover } from './LayerHover';

export const HoverMap = () => {
  const { vectorTileHoverState } = useLayers();

  // Show either target hover or vector tile hover, not both
  if (vectorTileHoverState.feature && vectorTileHoverState.position) {
    return <VectorTileHover />;
  }

  return (
    <>
      <TargetHover />
      <LayerHover />
    </>
  );
};
